import { render, staticRenderFns } from "./TicketOfficeSales.vue?vue&type=template&id=33195b91&scoped=true"
import script from "./TicketOfficeSales.vue?vue&type=script&lang=js"
export * from "./TicketOfficeSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33195b91",
  null
  
)

export default component.exports